export const villageIcon = "https://village-co-callback.s3.amazonaws.com/images/village.svg"